import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import RouterConstants from "../../../../constants/RouterConstants";
import { useAppStore } from "../../../../hooks/useStores";
import TgApp from "../../App/TgApp";

const TgImageGenerationDemo = () => {
	const { uiStore } = useAppStore();

	useEffect(() => {
		uiStore.showBackButton(RouterConstants.NEW_TG.DEMO.fullPath);

		return () => {
			uiStore.hideBackButton();
		};
	}, []);

	return <TgApp />;
};

export default observer(TgImageGenerationDemo);
